import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [forgotSent, setForgotSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#0F1115] flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <Link to="/" className="block text-center font-serif text-3xl text-[#FDFBF7]">
          Luz de <span className="italic text-[#D5C0A1]">Cádiz</span>
        </Link>
        <p className="text-center text-[10px] uppercase tracking-[0.3em] text-[#A0A3A9] mt-3 mb-10">Panel de propietario</p>

        <form data-testid="admin-login-form" onSubmit={submit} className="bg-[#181A1F] border border-[#2A2D35] p-8 flex flex-col gap-6">
          <input
            data-testid="admin-email"
            type="email"
            required
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="bg-transparent border-b border-[#2A2D35] focus:border-[#D5C0A1] outline-none py-3 text-sm text-[#FDFBF7] placeholder:text-[#A0A3A9]/60 transition-colors"
          />
          <input
            data-testid="admin-password"
            type="password"
            required
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="bg-transparent border-b border-[#2A2D35] focus:border-[#D5C0A1] outline-none py-3 text-sm text-[#FDFBF7] placeholder:text-[#A0A3A9]/60 transition-colors"
          />
          {error && <p data-testid="admin-login-error" className="text-xs text-[#E08A6C]">{error}</p>}
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="py-3.5 bg-[#D5C0A1] text-[#0F1115] text-xs uppercase tracking-[0.25em] hover:bg-[#FDFBF7] transition-colors disabled:opacity-50"
          >
            {loading ? "…" : "Entrar"}
          </button>
          {forgotSent ? (
            <p data-testid="forgot-sent" className="text-xs text-[#9DC4A8] text-center">
              Si el email es correcto, te hemos enviado un enlace para crear una contraseña nueva (revisa tu correo).
            </p>
          ) : (
            <button
              type="button"
              data-testid="forgot-password-link"
              onClick={async () => {
                if (!email.includes("@")) return setError("Escribe tu email arriba y luego pulsa aquí");
                try {
                  await api.post("/auth/forgot-password", { email });
                  setForgotSent(true);
                  setError("");
                } catch {
                  setError("No se pudo enviar. Inténtalo de nuevo.");
                }
              }}
              className="text-[10px] uppercase tracking-[0.2em] text-[#A0A3A9] hover:text-[#D5C0A1] transition-colors text-center"
            >
              ¿Olvidaste tu contraseña?
            </button>
          )}
        </form>
      </div>
    </div>
  );
}
